import { ApiImageContainer } from '@ibe/api';
import { OfferBaseData } from './supermodels/OfferBaseData';
import { CmsOfferPackage } from './CmsOfferPackage';

class CmsOffer extends OfferBaseData {
  specialOffer?: CmsOfferPackage[];

  hotelListBanner?: CmsHotelListBanner;

  offerPillAndCartBanner?: CmsOfferPillAndCartBanner;

  extrasBanner?: CmsExtrasBanner;

  get packages(): CmsOfferPackage[] {
    return this.specialOffer ?? [];
  }

  static fromRaw(data: Partial<CmsOffer>): CmsOffer {
    const instance = new CmsOffer();
    Object.assign(instance, data);
    return instance;
  }
}

export interface CmsHotelListBanner {
  definition?: string;
  isWithOfferDetailsPopup?: string;
  popupLinkText?: string;
  popupImage?: ApiImageContainer;
  popupText?: string;
}

export interface CmsOfferPillAndCartBanner {
  characteristicGroupCode?: string;
  pillDefinition?: string;
  cartText?: string;
}

export interface CmsExtrasBanner {
  definition?: string;
}

export default CmsOffer;

export enum HotelBannerStatusEnum {
  ON = 'enabled',
  OFF = 'disabled'
}
